<template>
	<div>
		<CommonHeader :setOrden="true" :showIcon="true" :showBackButton="true" :title="$t('myProfile')"></CommonHeader>
        <HeaderProfile></HeaderProfile>
		<div class="menu">
			<div @click="goToPersonalData()">
				<p>{{$t('personalData')}}</p>
				<span>&#8250;</span>
			</div>
			<div @click="goToPasswords()">
				<p>{{$t('password')}}</p>
				<span>&#8250;</span>
			</div>
			<!-- <div @click="goToSocialNetwork()">
				<p>{{$t('linkSocialNetworks')}}</p>
				<span>&#8250;</span>
			</div> -->
		</div>
	</div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import CommonHeader from '@/components/CommonHeader.vue'
import HeaderProfile from '@/components/HeaderProfile.vue'
@Component({
	components: {
        CommonHeader,
        HeaderProfile
	},
})
export default class PersonalInfo extends Vue {

	goToPersonalData(){
		this.$router.push('/personalinfoedit')
	}

	goToPasswords(){
		this.$router.push('/changepassword')
	}

	// goToSocialNetwork(){
	// 	this.$router.push('/connectsocialplatforms')
	// }
}
</script>
<style lang="scss" scoped>
p {
	margin: 0;
}
.menu {
	padding: 0 1em;
	div {
		margin: 1em 0;
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		p {
			color: rgba(117, 112, 112, 1);
			font-size: 1em;
			font-weight: 400;
			line-height: 24px;
		}
		span {
			font-weight: 400;
			font-size: 1.5em;
			color:  rgba(100, 105, 121, 1);

		}
	}
}
</style>